var _rect, _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 335,
    viewBox: "0 0 350 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.416748,
    width: 350,
    height: 334,
    rx: 20,
    fill: "#FBFBFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.031 124.149C172.031 125.332 171.069 126.293 169.886 126.293H153.886C151.63 126.293 149.421 127.207 147.816 128.804C146.188 130.432 145.29 132.585 145.29 134.881V150.881C145.29 152.065 144.329 153.026 143.145 153.026C141.961 153.026 141 152.065 141 150.881V134.881C141 131.449 142.343 128.208 144.782 125.777C147.181 123.37 150.493 121.996 153.886 121.996H169.886C171.069 121.996 172.031 122.957 172.031 124.141V124.149ZM169.878 197.149H153.878C151.614 197.149 149.397 196.235 147.8 194.623C146.18 193.01 145.29 190.857 145.29 188.553V172.553C145.29 171.37 144.329 170.408 143.145 170.408C141.961 170.408 141 171.37 141 172.553V188.553C141 192.009 142.343 195.242 144.766 197.657C147.149 200.065 150.478 201.439 153.878 201.439H169.878C171.061 201.439 172.023 200.478 172.023 199.294C172.023 198.11 171.061 197.149 169.878 197.149ZM191.192 126.293H207.192C209.48 126.293 211.633 127.183 213.262 128.804C214.882 130.432 215.788 132.593 215.788 134.881V150.881C215.788 152.065 216.749 153.026 217.933 153.026C219.117 153.026 220.078 152.065 220.078 150.881V134.881C220.078 131.457 218.735 128.224 216.296 125.769C213.85 123.346 210.616 122.004 207.192 122.004H191.192C190.009 122.004 189.047 122.965 189.047 124.149C189.047 125.332 190.009 126.293 191.192 126.293ZM215.78 172.482V188.482C215.78 190.77 214.89 192.923 213.27 194.551C211.641 196.172 209.48 197.077 207.192 197.077H191.192C190.009 197.077 189.047 198.039 189.047 199.222C189.047 200.406 190.009 201.367 191.192 201.367H207.192C210.616 201.367 213.85 200.025 216.304 197.586C218.727 195.139 220.07 191.906 220.07 188.482V172.482C220.07 171.298 219.109 170.337 217.925 170.337C216.741 170.337 215.78 171.298 215.78 172.482Z",
    fill: "url(#paint0_linear_2460_2835)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26 71.9861H149.629C138.09 71.9861 128.735 81.3405 128.735 92.8797V240.35C128.735 251.89 138.09 261.244 149.629 261.244H210.26C221.799 261.244 231.154 251.89 231.154 240.35V92.8797C231.154 81.3405 221.799 71.9861 210.26 71.9861Z",
    stroke: "#010F55",
    strokeWidth: 3.97217,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2460_2835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 130,
    width: 94,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.375 153.917C163.375 144.183 171.266 136.292 181 136.292C190.734 136.292 198.625 144.183 198.625 153.917C198.625 163.651 190.734 171.542 181 171.542C171.266 171.542 163.375 163.651 163.375 153.917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.692 209.163C148.995 191.578 163.344 177.417 181 177.417C198.657 177.417 213.005 191.578 213.308 209.164C213.328 210.33 212.656 211.398 211.596 211.884C202.278 216.16 191.914 218.542 181.001 218.542C170.088 218.542 159.722 216.159 150.404 211.883C149.344 211.397 148.672 210.329 148.692 209.163Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2460_2835)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 128.417,
    width: 61,
    height: 73,
    rx: 6,
    fill: "url(#paint1_linear_2460_2835)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2835",
    x1: 112.374,
    y1: 88.3688,
    x2: 236.52,
    y2: 177.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2460_2835",
    x1: 128.918,
    y1: 97.5173,
    x2: 235.454,
    y2: 162.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#1AE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79EE5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.391,
    height: 193.23,
    fill: "white",
    transform: "translate(127 70)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfieIcon);
export default __webpack_public_path__ + "static/media/selfie-icon.0f520bb1f78d09796e72a0a0c4ad415c.svg";
export { ForwardRef as ReactComponent };